import styled from 'styled-components';
import { colors } from '@keen.io/colors';

export const Container = styled.div`
  padding: 25px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.white[500]};
`;

export const Wrapper = styled.div`
  margin-left: 10px;
`;
